import type { WorkflowStatus } from '@makemydeal/dr-sales-checkin-types';
import { SET_WORKFLOW_STATUS, SET_WORKFLOW_EVALUATION } from './workflowActionTypes';

export const setWorkflowStatus = (status: WorkflowStatus) => ({
    type: SET_WORKFLOW_STATUS,
    payload: status
});

export const setWorkflowEvaluation = (value: boolean) => ({
    type: SET_WORKFLOW_EVALUATION,
    payload: value
});
